<template>
  <Detail :businessInfo="businessInfo" />
</template>
<script>
import Detail from "../detail.vue";
import { softwareByProductApi } from "@/api/website.js";
import { prefix } from "@/utils/env";
export default {
  name: "digital-airoad",
  components: {
    Detail,
  },
  data() {
    return {
      businessInfo: {
        name: "EICAD",
        icon: require("@/assets/images/digitalImg/eicad_icon.png"),
        bgImg: require("@/assets/images/digitalImg/airoad_bg.png"),
        banner: {
          icon: require("@/assets/images/digitalImg/eicad_icon.png"),
          title: "EICAD：专业覆盖广，联动效率高",
          subTitle: "集成交互式道路与立交设计软件",
          downloadBtnList: [
            {
              label: "下载客户端 For AutoCAD",
              otherLabel: "下载客户端 For AutoCAD",
              fileUrl: "",
              fileName: "AutoCAD",
            },
            {
              label: "下载客户端 For 中望CAD",
              otherLabel: "下载客户端 For 中望CAD",
              fileUrl: "",
              fileName: "ZWCAD",
            },
          ],
          posterImg: require("@/assets/images/digitalImg/video_eicad.png"),
          videoUrl: `${prefix}/static/video/eicad_cn.mp4`,
        },
        all: {
          title: "什么是 EICAD？",
          content:
            "EICAD经过多年的发展，目前已覆盖公路、市政及轨道交通领域，是一款含有外业调查、数字地面模型、路线、互通立交、路基路面、桥涵、隧道、交通工程、给排水等多个专业模块的数字化设计软件全家桶。EICAD设计软件始终坚持“提升设计效率和设计品质”这一理念，持续创新，不断丰富产品功能，为客户创造价值，为基础设施建设提供优质的数字化软件产品。",
          imgLists: [
            {
              id: 1,
              title: "三维正向设计，品质高（1/3） ",
              img: require("@/assets/images/digitalImg/eicad_img1.png"),
            },
            {
              id: 2,
              title: "数据联动，修改便捷（2/3）",
              img: require("@/assets/images/digitalImg/eicad_img2.png"),
            },
            {
              id: 3,
              title: "图形化交互模式，打通数据链（3/3）",
              img: require("@/assets/images/digitalImg/eicad_img3.png"),
            },
          ],
        },
        highlights: {
          title: "为什么选择 EICAD？",
          lists: [
            {
              id: 1,
              icon: require("@/assets/images/digitalImg/eicad_icon3.png"),
              title: "1000+",
              content: "近两年来帮助用户完成立交方案1000余座",
            },
            {
              id: 2,
              icon: require("@/assets/images/digitalImg/eicad_icon4.png"),
              title: "80%",
              content:
                "设计软件拥有1000余家设计院客户，包括交通/市政行业80%甲级设计院",
            },
          ],
        },

        function: {
          title: "EICAD 的功能！",
          lists: [
            {
              id: 1,
              img: require("@/assets/images/digitalImg/eicad_function01.png"),
              title: "专业模块齐全，持续升级",
              content: [
                "图形化交互模式，打通数据链",
                "一键绘制枢纽/互通偏置线",
                "强大的复杂线路设计和立交设计功能",
                "数据联动，修改便捷，效率高（纵断面自动拉坡）",
              ],
            },
            {
              id: 2,
              img: require("@/assets/images/digitalImg/eicad_function02.png"),
              title: "互通立交设计",
              content: [
                "EICAD互通立交模块汇集了国内领先的路线曲线型设计思想，用户可以使用数据输入、鼠标拖动等方法，更加灵活地处理线位。道路中线上的若干夹点的任意拖拽，如同摆弄桌面上的一根绳索，方便用户快速、准确地完成互通立交布线和成图。",
                "软件同时实现了单喇叭、双喇叭、菱形、苜蓿叶型等常见的互通立交形式的全自动布线，使用该功能，一个平面方案图的完成时间小于 1 分钟。",
              ],
            },
            {
              id: 3,
              img: require("@/assets/images/digitalImg/eicad_function03.png"),
              title: "边坡防护设计",
              content:
                "支持从道路模型中导出并绘制边坡立面展开图，根据设计要求自定义防护（措施）类型和单位工程材料数量表，设计完成后可一键输出工点设计图及防护工程数量表。",
            },
            {
              id: 4,
              img: require("@/assets/images/digitalImg/eicad_function03.png"),
              title: "涵洞通道设计",
              content: [
                "以通用图为基础，实现了涵洞布置图、工程量统计一体化设计，可利用EXCEL批量导入涵洞表完成涵洞的设计与工程量计算，同时支持三维模式查看，更直观。",
              ],
            },
          ],
        },
        support: {
          title: "EICAD 的用户支持",
          // documnentUrl: "/download?anchor=manual",
          documnentUrl: "/dnnweb/helpDocuments?soft=EICAD&language=zh",
          videosUrl: "/academy?anchor=EICAD",
        },
        contact: {
          bgImg: require("@/assets/images/digitalImg/eicad_contactbg.png"),
          title: "立即获取EICAD！",
          subTitle: "狄诺尼数字设计软件产品线，为您带来一站式设计解决方案",
          downLoadBtnText: "下载产品手册",
          downLoadBtnUrl: "/download?anchor=manual",
          contactBtnText: "让销售人员联系您",
          contactBtnUrl: "",
        },
        combination: {
          title: "使用其他软件配合 EICAD 进行工作！",
          lists: [
            {
              id: 1,
              img: require("@/assets/images/digitalImg/eicad_combination01.png"),
              title: "使用EICAD",
              subTitle: "完成“宝顶山-北山快速通道工程”设计",
              content: "- EICAD演示案例",
              caseUrl: "",
            },
            {
              id: 2,
              img: require("@/assets/images/digitalImg/eicad_combination01.png"),
              title: "使用EICAD",
              subTitle: "完成“宁安告诉安远互通”设计",
              content: "- EICAD演示案例",
              caseUrl: "",
            },
            {
              id: 3,
              img: require("@/assets/images/digitalImg/eicad_combination01.png"),
              title: "使用EICAD",
              subTitle: "完成“沪武高速段复杂枢纽”设计",
              content: "- EICAD演示案例",
              caseUrl: "",
            },
          ],
          softwares: [
            {
              name: "AIRoad",
              icon: require("@/assets/images/digitalImg/airoad_icon3.png"),
              desc: "依托自主研发的BIM引擎，基于GIS、航测遥感等数据构建数字化地形，通过动态交互式布线，自动构建方案模型。",
            },
            // {
            //   name: "Report3D",
            //   icon: require("@/assets/images/digitalImg/report3d_icon4.png"),
            //   desc: "A reporting tool developed with a game engine, Report3D supports real-time rendering for efficient scene creation and PPT production across various engineering projects.",
            // },
          ],
        },
      },
    };
  },
  created() {
    this.getSoftware();
  },
  methods: {
    async getSoftware() {
      await softwareByProductApi({ productId: "2" }).then((res) => {
        // console.log(res);
        if (res.code === 200) {
          if (res.data.length > 0 && res.data[0].pathUrlIdList.length > 0) {
            let AutoCADTemp = res.data.find(
              (item) => item.name.indexOf("AutoCAD") > -1,
            );
            let ZWCADTemp = res.data.find(
              (item) => item.name.indexOf("ZWCAD") > -1,
            );
            this.businessInfo.banner.downloadBtnList[0].fileUrl =
              AutoCADTemp.pathUrlIdList[0].path;
            this.businessInfo.banner.downloadBtnList[0].fileName =
              AutoCADTemp.pathUrlIdList[0].fileTitle;

            this.businessInfo.banner.downloadBtnList[1].fileUrl =
              ZWCADTemp.pathUrlIdList[0].path;
            this.businessInfo.banner.downloadBtnList[1].fileName =
              ZWCADTemp.pathUrlIdList[0].fileTitle;
          } else {
            this.businessInfo.banner.downloadBtnList[0].fileUrl = "";
            this.businessInfo.banner.downloadBtnList[1].fileUrl = "";
            this.businessInfo.banner.downloadBtnList[0].fileName = "";
            this.businessInfo.banner.downloadBtnList[1].fileName = "";
          }
        }
      });
    },
  },
};
</script>
